export default {"src":"/uk/_next/static/media/Lock-round-open.d635605e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};